import React from 'react';
import Button from '../Button/Button';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import defaultImage from './images/error.png';
import './DataError.css';

function DataError({message, action, actionLabel, maxWidth, padding, iconSize, fontSize}) {
    const hasAction = () => {
        return action && actionLabel;
    };

    const handleActionClick = () => {
        if (action) action();
    };

    const containerStyle = () => {
        return {
            padding: padding !== undefined ? padding : 20,
            maxWidth: maxWidth ? maxWidth : 300
        };
    };

    const messageStyle = () => {
        return {
            fontSize: fontSize ? fontSize : 18
        };
    };

    const renderButton = (label, minWidth, onClick) => {
        return (
            <div className='data-error_action'>
                <Button
                    icon={undefined}
                    label={label}
                    labelColor='#FFFFFF'
                    backgroundColor='#FF3D00'
                    borderColor='#FF3D00'
                    borderWidth={0}
                    borderRadius={5}
                    padding='10px 15px'
                    paddingTarget='label'
                    margin={0}
                    width='100%'
                    minWidth={minWidth !== undefined ? minWidth : 'auto'}
                    maxWidth='100%'
                    height='auto'
                    minHeight={undefined}
                    maxHeight={undefined}
                    transition='container'
                    fontSize={18}
                    boxShadow='unset'
                    isLoading={false}
                    loadLabel={undefined}
                    disabled={false}
                    showPulseEffect={false}
                    notificationNumber={undefined}
                    notificationBackgroundColor={undefined}
                    notificationLabelColor={undefined}
                    onClick={onClick}
                />
            </div>
        );
    };

    return (
        <div className='data-error' style={containerStyle()}>
            <div className='data-error_image-container'>
                <ImageWrapper
                    image={defaultImage}
                    alt='Error'
                    display='block'
                    width={iconSize || 200}
                    height='auto'
                    errorWidth={undefined}
                    errorHeight={undefined}
                    errorPadding={undefined}
                    margin={5}
                    borderRadius={0}
                    transition={true}
                    loadDelay={0}
                    onLoad={undefined}
                    onMouseEnter={undefined}
                    onMouseLeave={undefined}
                />
            </div>
            {message ? <p className='data-error_message' style={messageStyle()}>{message}</p> : undefined}
            {hasAction() && (
                <div className='data-error_actions'>
                    {hasAction() && renderButton(actionLabel ? actionLabel : '', undefined, handleActionClick)}
                </div>
            )}
        </div>
    )
}

export default DataError;